import { render, staticRenderFns } from "./judgmentOption.vue?vue&type=template&id=7a04aa7a&scoped=true"
import script from "./judgmentOption.vue?vue&type=script&lang=js"
export * from "./judgmentOption.vue?vue&type=script&lang=js"
import style0 from "./judgmentOption.vue?vue&type=style&index=0&id=7a04aa7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a04aa7a",
  null
  
)

export default component.exports